import { jsx, Fragment } from 'react/jsx-runtime';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { E as EGDSList, a as EGDSListItem } from '../list-item/index-chunk.esm.js';
import { b as EGDSSpacing, c as EGDSSpacingHr } from '../spacing-hr/index-chunk.esm.js';
import { a as EGDSParagraph, E as EGDSHeading, c as EGDSText } from '../text/index-chunk.esm.js';
import { E as EGDSLink } from '../link/index-chunk.esm.js';

const DisallowedElementsArray = [
    'audio',
    'form',
    'iframe',
    'input',
    'noscript',
    'script',
    'style',
    'textarea',
];

const EGDSUnformattedHtml = (props) => {
    const { elementsToReplace, htmlToParse, plainTextElement: PlainTextElement } = props;
    const parseOptions = {
        replace: (domNode) => {
            const { children, attribs, name } = domNode;
            const generateChildren = () => jsx(Fragment, { children: domToReact(children, parseOptions) });
            if (elementsToReplace?.hasOwnProperty(name)) {
                const Component = elementsToReplace[name];
                const attrsToProps = attributesToProps(attribs);
                return jsx(Component, { ...attrsToProps, children: generateChildren() });
            }
            if (DisallowedElementsArray.includes(name)) {
                return jsx(Fragment, {});
            }
        },
    };
    if (htmlToParse) {
        const elements = parse(htmlToParse, parseOptions);
        return (jsx(Fragment, { children: PlainTextElement && elements === htmlToParse ? jsx(PlainTextElement, { children: elements }) : elements }));
    }
    else if (props.children) {
        // Backwards compatible addition:
        // If children are passed in, keep old styles
        return jsx("div", { children: props.children });
    }
    else {
        return null;
    }
};
const headingStyle = (curriedProps) => {
    const HeadingComponent = (props) => {
        return (jsx(EGDSSpacing, { margin: { blockstart: 'four' }, children: jsx(EGDSHeading, { ...props, ...curriedProps, children: props.children || null }) }));
    };
    return HeadingComponent;
};
const EGDSUnformattedHtmlReplaceDefaults = {
    h1: headingStyle({ size: 1, tag: 'h1' }),
    h2: headingStyle({ size: 2, tag: 'h2' }),
    h3: headingStyle({ size: 3, tag: 'h3' }),
    h4: headingStyle({ size: 4, tag: 'h4' }),
    h5: headingStyle({ size: 5, tag: 'h5' }),
    h6: headingStyle({ size: 6, tag: 'h6' }),
    hr: () => jsx(EGDSSpacingHr, {}),
    li: (props) => jsx(EGDSListItem, { children: props.children || null }),
    ol: (props) => (jsx(EGDSSpacing, { margin: { blockstart: 'two' }, children: jsx(EGDSList, { type: "ordered", children: props.children || null }) })),
    p: (props) => jsx(EGDSParagraph, { size: 2, children: props.children || null }),
    ul: (props) => (jsx(EGDSSpacing, { margin: { blockstart: 'two' }, children: jsx(EGDSList, { children: props.children || null }) })),
    a: (props) => {
        const { children, href } = props;
        return (jsx(EGDSLink, { children: jsx("a", { href: href, children: children }) }));
    },
};
EGDSUnformattedHtml.defaultProps = {
    elementsToReplace: EGDSUnformattedHtmlReplaceDefaults,
    plainTextElement: (props) => jsx(EGDSText, { size: 300, children: props.children || null }),
};

export { DisallowedElementsArray as D, EGDSUnformattedHtml as E, EGDSUnformattedHtmlReplaceDefaults as a };
//# sourceMappingURL=index-chunk.esm.js.map
